import React from 'react';
import AbstractWidget from './AbstractWidget';
import { Typography } from 'material-ui';
import styles from './ImageWidget.css';
import { getAccountName } from '../../components/Utils/UserFunctions';

class ImageWidget extends AbstractWidget {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
        this.accountName = getAccountName();
    }

    getPosition(labels, type) {
        if (labels) {
            let pos = labels[type].key;
            if (pos.indexOf('upper') !== -1) {
                return 'top';
            }
            if (pos.indexOf('lower') !== -1) {
                return 'bottom';
            }
        }
        return 'top';
    }

    getLabelObject(labels) {
        let lbo = {
            position: 'top'
        };
        labels.map(l => {
            lbo[l.key.replace('.', '_')] = l.value;
            //  parte superior imagen
            if (l.key === 'upperHeader.text') {
                lbo.position = 'top';
            }
            // centro de la imagen
            if (l.key === 'middleHeader.text') {
                lbo.position = 'middle';
            }
            // parte inferior de la imagen
            if (l.key === 'bottomHeader.text') {
                lbo.position = 'bottom';
            }
            //por debajo de la imagen
            if (l.key === 'lowerHeader.text') {
                lbo.position = 'baseline';
            }
        });
        return lbo;
    }

    render() {
        const { widget, className } = this.props;
        let title = this.getLabels(widget.labels, 'Header.text');
        let subTitle = this.getLabels(widget.labels, 'Detail.text');
        let textsParams = this.getLabelObject(widget.labels || []);
        let pos = textsParams.position;
        let hasPrices = textsParams.priceBefore_text && textsParams.priceBefore_text !== '' ? ' hasPrices' : '';
        let cssPoss = pos === 'baseline' ? 'cmsImageWidgetBottom' : '';
        const cmsClassName = !widget.image.degraded ? 'cmsImageWidgetTextContainer' : 'cmsImageWidgetTextContainer gradient';
        return (widget ?
            <div className={cssPoss + ' cmsImageWidget ' + (className ? className : '') + (widget.hidden ? ' hidden' : '')}>
                <div className="content">
                    <div >
                        <img src={widget.image && widget.image.url ? widget.image.url : ''} alt='Some alternative text'/>
                    </div>               
        
                    {pos != 'baseline' ?
                        <div>
                            <div className={cmsClassName}>
                                <div className="cmsImageWidgetText" style={{ verticalAlign: pos }}>
                                    {title && pos !== 'baseline' ? <Typography variant="display2" gutterBottom dangerouslySetInnerHTML={{ __html: title }}></Typography> : ''}
                                    {subTitle && pos !== 'baseline' ? <Typography dangerouslySetInnerHTML={{ __html: subTitle }}></Typography> : ''}
                                    <div className={'tinyButtonBar' + hasPrices}>
                                        {this.getAction(widget)}
                                        {textsParams.priceBefore_text &&
                                            <div>
                                                <Typography component="p" className="cmsImageWidgetPrices"><span><del>{textsParams.priceBefore_text}</del> -{textsParams.discount_text}</span><strong>{textsParams.priceAfter_text}</strong></Typography>
                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        : ''}
                    {pos === 'baseline' ?
                        <div className="cmsImageWidgetTextContainer gradient" style={{background: 'white'}}>
                            <div className="cmsImageWidgetText">
                                {title ? <Typography variant="display2" gutterBottom dangerouslySetInnerHTML={{ __html: title }}></Typography> : ''}
                                {subTitle ? <Typography dangerouslySetInnerHTML={{ __html: subTitle }}></Typography> : ''}
                                <div className={'tinyButtonBar' + hasPrices}>
                                    {this.getAction(widget)}
                                    {textsParams.priceBefore_text &&
                                        <div>
                                            <Typography component="p" className="cmsImageWidgetPrices"><span><del>{textsParams.priceBefore_text}</del> -{textsParams.discount_text}</span><strong>{textsParams.priceAfter_text}</strong></Typography>
                                        </div>}
                                </div>
                            </div>
                        </div>
                        : ''}
                </div>
            </div >
            : ''
        );
    }
}

export default (ImageWidget);


// WEBPACK FOOTER //
// ./src/cms/widgets/ImageWidget.js